import React, { useState, useEffect, useCallback } from "react";
import { ACTIVE_API_BASE_URL } from "../config/apiConfig";
import apiClient from "../api/axiosClient";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/FormProduction.css";
import SidebarGuideline from "./SidebarGuideline";
import { downloadFile } from "../common";

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const TEXTAREA_MAX_LENGTH = 300;
const PHONE_MAX_LENGTH = 10;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const COMMENT_MAX_LENGTH = 200;

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
const nameRegex = /^[A-Za-z\s]*$/;

const RegistrationYF = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [fieldErrors, setFieldErrors] = useState({});
  const [activeItem, setActiveItem] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);
  const [disableSave, setDisableSave] = useState(false);

  const [formData, setFormData] = useState({
    Organisationname: "",
    category: "Young Achiever of the Year(Female)",
    mailingAddress: "",
    authorityName: "",
    authorityTitle: "",
    authorityPhone: "",
    authorityLandline: "",
    authorityEmail: "",
    HREmail: "",
    HRName: "",
    HRPhone: "",
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    contactapplicant: "",
    Applicantjoining: "",
    Applicantdetails: "",
    Applicantprofile: "",
    Applicantdesignation: "",
    yf_applicant_name: "",
    ApplicantDOB: "",
    companyProfile: "",
    approvingAuthoritySignature: "",
    declaration: false,
    comment: "",
    YF_1: "",
    YF_2: "",
    YF_3: "",
    YF_4: "",
    YF_5: "",
    YF_6: "",
    attachments1: { description: "", file: null },
    attachments2: { description: "", file: null },
    attachments3: { description: "", file: null },
    attachments4: { description: "", file: null },
  });

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info");
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(JSON.parse(stored));
        setFormId(`Registration_YF_${user.id}`);

        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          Organisationname: user.organisation_name || "",
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
    }
  }, []);

  // This use Effect Prefill user Data using api;
  useEffect(() => {
    console.log("called yf prefill useEffect");
    if (userInfo) {
      prefillFormData();
    } else {
      console.warn(
        `userInfo OR formId is invalid; Kindly check the method. and data`
      );
    }
  }, [userInfo, formId]);

  const isSubmited = () => formData?.form_mode === "submit" || disableSave;

  useEffect(() => {}, []);

  function prefillFormData() {
    const url = `/registration-youngfemale/?form_id=${formId}`;
    console.log("prefill url:", url);

    apiClient
      .get(url)
      .then((res) => {
        if (!Array.isArray(res.data) || res.data.length !== 1) {
          console.warn("prefill: response not a single item, skipping");
          return;
        }

        const item = res.data[0];

        // Primary key (server variations)
        setPkId(item.id ?? item.pk ?? item.pk_id ?? 0);

        // possible user object returned by server
        const serverUser =
          item.user ??
          item.user_info ??
          (item.user_id ? { id: item.user_id } : null);

        // helper to normalise boolean-ish values
        const boolish = (v) =>
          v === true || v === "true" || v === "1" || v === 1 || v === "yes";

        const newFields = {
          // Identity / Org Info
          Organisationname:
            item.organisation_name ??
            item.organisationName ??
            item.company_name ??
            item.companyName ??
            "",
          category: item.category ?? item.cat ?? "",
          mailingAddress:
            item.mailing_address ??
            item.mailingAddress ??
            item.mailing_address_line ??
            "",

          // User meta (these are merged from localStorage in handleSubmit, but useful to prefill)
          userid:
            item.userid ??
            item.user_id ??
            (serverUser && serverUser.id) ??
            item.created_by ??
            "",
          firstname:
            item.firstname ??
            item.first_name ??
            (serverUser && serverUser.first_name) ??
            item.contact_first_name ??
            "",
          lastname:
            item.lastname ??
            item.last_name ??
            (serverUser && serverUser.last_name) ??
            item.contact_last_name ??
            "",
          company_name:
            item.company_name ??
            item.companyName ??
            item.organisation_name ??
            newFields?.Organisationname ??
            "",

          // Approving Authority
          authorityName:
            item.authority_name ?? item.authorityName ?? item.authority ?? "",
          authorityTitle:
            item.authority_title ??
            item.authorityTitle ??
            item.authority_designation ??
            "",
          authorityPhone:
            item.authority_phone ??
            item.authorityPhone ??
            item.authorityTelephone ??
            "",
          authorityLandline:
            item.authority_landline ??
            item.authorityLandline ??
            item.authority_land_line ??
            "",
          authorityEmail:
            item.authority_email ??
            item.authorityEmail ??
            item.authority_contact_email ??
            "",

          // Corporate HR
          HRName:
            item.hr_name ??
            item.hrName ??
            item.HRName ??
            item.corporate_hr_name ??
            "",
          HRPhone:
            item.hr_phone ??
            item.hrPhone ??
            item.HRPhone ??
            item.corporate_hr_phone ??
            "",
          HREmail:
            item.hr_email ??
            item.hrEmail ??
            item.HREmail ??
            item.corporate_hr_email ??
            "",

          // Contact / Nodal Official
          contact_name:
            item.contact_name ?? item.contactName ?? item.nodal_name ?? "",
          contact_phone:
            item.contact_phone ?? item.contactPhone ?? item.nodal_phone ?? "",
          contact_email:
            item.contact_email ?? item.contactEmail ?? item.nodal_email ?? "",

          // Applicant Details
          contactapplicant:
            item.contact_applicant ?? item.contactapplicant ?? "",
          yf_applicant_name:
            item.yf_applicant_name ?? item.yf_applicant_name ?? "",
          ApplicantDOB:
            item.applicant_dob ?? item.applicantDOB ?? item.dob ?? "",
          Applicantdesignation:
            item.applicant_designation ??
            item.applicantDesignation ??
            item.designation ??
            "",
          Applicantprofile:
            item.applicant_profile ??
            item.applicantProfile ??
            item.profile ??
            "",
          Applicantdetails:
            item.applicant_details ??
            item.applicantDetails ??
            item.details ??
            "",
          Applicantjoining:
            item.applicant_joining ??
            item.applicantJoining ??
            item.joining_date ??
            "",

          // Qualitative Info
          companyProfile:
            item.company_profile ??
            item.companyProfile ??
            item.profile_text ??
            "",
          awardJustification:
            item.award_justification ??
            item.awardJustification ??
            item.award_justification_text ??
            item.award_reason ??
            "",
          comment: item.comment ?? item.notes ?? "",
          declaration: boolish(item.declaration) ?? false,

          // Quantitative / YF Answers (young female)
          YF_1: item.yf_1 ?? item.yf1 ?? item.YF_1 ?? item.yf_01 ?? "",
          YF_2: item.yf_2 ?? item.yf2 ?? item.YF_2 ?? "",
          YF_3: item.yf_3 ?? item.yf3 ?? item.YF_3 ?? "",
          YF_4: item.yf_4 ?? item.yf4 ?? item.YF_4 ?? "",
          YF_5: item.yf_5 ?? item.yf5 ?? item.YF_5 ?? "",
          YF_6: item.yf_6 ?? item.yf6 ?? item.YF_6 ?? "",

          // form mode / meta
          form_mode: item.form_mode ?? item.formMode ?? item.mode ?? "draft",
          form_id: item.form_id ?? item.formId ?? formId ?? "",
        };

        // Attachments 1..4 (server commonly returns either attachments1 or attachments1_url/path)
        [1, 2, 3, 4].forEach((n) => {
          const descKey = `attachments${n}_desc`;
          const fileKey = `attachments${n}`;
          const urlKey = `${fileKey}_url`;
          const pathKey = `${fileKey}_path`;
          const altDescKey = `${fileKey}Desc`;

          newFields[fileKey] = {
            description:
              item[descKey] ??
              item[altDescKey] ??
              item[`${fileKey}Desc`] ??
              item[`${fileKey}_description`] ??
              "",
            file: null, // file object stays null until user selects a file
            url:
              item[fileKey] ??
              item[urlKey] ??
              item[pathKey] ??
              item[`${fileKey}_url_path`] ??
              null,
          };
        });

        // Approving authority signature: keep file null (user must reupload) + URL preview if returned
        newFields.approvingAuthoritySignature = null;
        newFields.approvingAuthoritySignatureUrl =
          item.approving_authority_file ??
          item.approving_authority_file_url ??
          item.approvingAuthorityFileUrl ??
          item.approving_authority_signature ??
          item.approving_authority_signature_url ??
          null;

        // Extra meta returned from server (keep if present)
        if (item.id) newFields.id = item.id;
        if (item.pk) newFields.pk = item.pk;
        if (item.created_at) newFields.created_at = item.created_at;
        if (item.updated_at) newFields.updated_at = item.updated_at;

        // Merge immutably with previous state so controlled inputs update correctly
        setFormData((prev) => ({ ...prev, ...newFields }));
      })
      .catch((err) => {
        console.error("prefillFormData error:", err);
      });
  }

  const [error, setError] = useState("");
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const awardTitle =
    location.state?.awardTitle || "Young Achiever of the Year(Female)";

  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let applicableMaxLength = FIELD_MAX_LENGTH;
    if (name === "companyProfile")
      applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
    else if (name === "comment") applicableMaxLength = COMMENT_MAX_LENGTH;
    else if ((name === "Applicantdetails", "Applicantprofile"))
      applicableMaxLength = 100;
    else if (["YF_1", "YF_2", "YF_3", "YF_4", "YF_5", "YF_6"].includes(name)) {
      applicableMaxLength = COMMENT_MAX_LENGTH;
    }

    if (typeof value === "string") {
      if (name === "companyProfile") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 300) {
          alert("Maximum 300 words allowed");
          return;
        }
      } else if (name === "comment") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words allowed in Comments.");
          return;
        }
      } else if (name === "Applicantdetails") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 100) {
          alert("Maximum 100 words are allowed ");
          return;
        }
      } else if (name === "Applicantprofile") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 100) {
          alert("Maximum 100 words are allowed ");
          return;
        }
      } else if (name === "YF_1") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words are allowed");
          return;
        }
      } else if (name === "YF_2") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words are allowed ");
          return;
        }
      } else if (name === "YF_3") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words are allowed ");
          return;
        }
      } else if (name === "YF_4") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words allowed ");
          return;
        }
      } else if (name === "YF_5") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words are allowed ");
          return;
        }
      } else if (name === "YF_6") {
        const wordCount = value.trim().split(/\s+/).length;
        if (wordCount > 200) {
          alert("Maximum 200 words are allowed");
          return;
        }
      } else if (value.length > applicableMaxLength) {
        alert(`Value cannot exceed ${applicableMaxLength} characters.`);
        return;
      }
    }

    if (type === "text" && value.length > applicableMaxLength) {
      alert(`Value must not exceed ${applicableMaxLength} characters.`);
      return;
    }

    // Name validation
    if (
      ["Organisationname", "authorityName", "contact_name", "HRName"].includes(
        name
      )
    ) {
      if (!nameRegex.test(value) && value !== "") {
        alert("Only letters and spaces are allowed.");
        return;
      }
    }

    // Phone validation
    if (
      name === "authorityPhone" ||
      name === "HRPhone" ||
      name === "contact_phone" ||
      name === "contactapplicant"
    ) {
      const numericValue = value.replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH);
      if (numericValue.length > PHONE_MAX_LENGTH) {
        alert("Phone number must not exceed 10 digits.");
        return;
      }
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Clear errors on valid input
    if (name === "Organisationname" && value && currentStep === 1) setError("");
    if (name === "mailingAddress" && value.trim() && currentStep === 1)
      setError("");
    if (name === "authorityName" && value && currentStep === 2) setError("");
    if (name === "authorityEmail" && value && currentStep === 2) setError("");
    if (name === "contactapplicant" && value && currentStep === 2) setError("");
    if (name === "ApplicantDOB" && value && currentStep === 2) setError("");
    if (name === "Applicantdesignation" && value && currentStep === 2)
      setError("");
    if (name === "Applicantjoining" && value && currentStep === 2) setError("");
    if (name === "Applicantprofile" && value && currentStep === 2) setError("");
    if (name === "Applicantdetails" && value && currentStep === 2) setError("");
  };

  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    // setCopyApplicantData(checked);

    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem("user_info"));
      if (userInfo) {
        model.contact_name = userInfo.applicant_name;
        model.contact_phone = userInfo.applicant_phone;
        model.contact_email = userInfo.email;
      }
    }

    setFormData((prev) => ({ ...prev, ...model }));

    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  const viewFile = async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath
      .split("/")
      .filter(
        (val) =>
          val !== "" && // remove empty strings
          val !== "http:" &&
          val !== "https:" &&
          val !== "media" &&
          !val.startsWith("award") &&
          !val.startsWith("localhost")
      )
      .join("/");

    downloadFile(extractPath);
  };
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === "file" && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024;

      if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for attachments.");
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for attachments.");
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for the signature.");
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for the signature.");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        approvingAuthoritySignature: file,
      }));
    }
  };

  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.mailingAddress.trim()) {
        alert("Mailing address is required.");
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert("Authority name is required.");
        return;
      }
      if (!formData.authorityTitle) {
        alert("Authority Designation is required.");
        return;
      }
      if (
        !formData.authorityEmail ||
        !emailRegex.test(formData.authorityEmail)
      ) {
        alert("Please enter a valid Authority email.");
        return;
      }
      // if (!formData.authorityPhone || !phoneRegex.test(formData.authorityPhone)) {
      //     alert('Authority phone must be exactly 10 digits.');
      //     return;
      // }
      if (!formData.authorityLandline) {
        alert("Authority Landline is required.");
        return;
      }
      if (!formData.HRName) {
        alert("HR name is required.");
        return;
      }
      if (!formData.HREmail || !emailRegex.test(formData.HREmail)) {
        alert("Please enter a valid HR email.");
        return;
      }
      if (!formData.HRPhone || !phoneRegex.test(formData.HRPhone)) {
        alert("HR phone must be exactly 10 digits.");
        return;
      }
      if (
        !formData.contactapplicant ||
        !phoneRegex.test(formData.contactapplicant)
      ) {
        alert("Applicant Contact number must be exactly 10 digits.");
        return;
      }
      if (!formData.ApplicantDOB) {
        alert("Applicant DOB is required.");
        return;
      }
      if (!formData.Applicantdesignation) {
        alert("Applicant designation is required.");
        return;
      }
      if (!formData.Applicantjoining) {
        alert("Applicant joining date is required.");
        return;
      }
      if (!formData.Applicantprofile) {
        alert("Applicant profile is required.");
        return;
      }
      if (!formData.Applicantdetails) {
        alert("Applicant details are required.");
        return;
      }
      if (formData.contactEmail && !emailRegex.test(formData.contactEmail)) {
        alert("Please enter a valid Contact email.");
        return;
      }
      if (
        formData.contact_phone &&
        !phoneRegex.test(formData.contact_phone) &&
        !copyApplicantData
      ) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (!formData.companyProfile) {
        alert("Company Profile is required.");
        return;
      }
    }
    if (currentStep === 3 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return; // Stay on step
      }
    }
    if (currentStep === 4 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return; // Stay on step
      }
    }
    setError("");
    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem(
      "registration-youngfemaleDraft",
      JSON.stringify({ formData })
    );
    handleSubmit(null);
    alert("Draft Saved!");
  };

  //Final Submit button

  useEffect(() => {
    if (userInfo) {
      validateFormCount().catch((err) => {
        alert(`${err.message}`);
        setDisableSave(true);
      });
    }
  }, [userInfo]);

  const validateFormCount = async () => {
    const url = `/registration-youngfemale/?organisation_name=${userInfo.organisation_name}&form_mode=submit`;
    const res = await apiClient.get(url);

    if (res?.data?.length === 3) {
      // disable buttons
      setDisableSave(true);
      throw new Error(
        "You have reached the maximum limit of 3 Applications for this organisation."
      );
    }
  };

  async function handleSubmit(event, clickType = "draft") {
    if (event) {
      event?.preventDefault();
    }
    try {
      await validateFormCount();

      // 1) Make a local copy of formData so we don't rely on async state updates
      let payload = { ...formData };

      // 2) Merge user_info synchronously (don't call setFormData here)
      try {
        const raw = localStorage.getItem("user_info");
        if (raw) {
          const u = JSON.parse(raw);
          payload.userid = u.id || "";
          payload.firstname = u.first_name || "";
          payload.lastname = u.last_name || "";
          payload.company_name = u.organisation_name ?? payload.company_name;
          payload.Organisationname =
            u.organisation_name ?? payload.Organisationname;
        }
      } catch (err) {
        console.warn("Failed to load user_info:", err);
      }

      // Build FormData
      const fd = new FormData();
      fd.append("organisation_name", formData.Organisationname);
      fd.append("category", formData.category);
      fd.append("firstname", formData.firstname);
      fd.append("lastname", formData.lastname);
      fd.append("userid", formData.userid);
      fd.append("company_name", formData.company_name);
      fd.append("mailing_address", formData.mailingAddress || "");

      // Approving Authority
      fd.append("authority_name", formData.authorityName || "");
      fd.append("authority_title", formData.authorityTitle || "");
      fd.append("authority_phone", formData.authorityPhone || "");
      fd.append("authorityLandline", formData.authorityLandline || "");
      fd.append("authority_email", formData.authorityEmail || "");

      // Corporate HR
      fd.append("hr_name", formData.HRName || "");
      fd.append("hr_phone", formData.HRPhone || "");
      fd.append("hr_email", formData.HREmail || "");

      // Contact (Nodal Official)
      fd.append("contact_name", formData.contact_name || "");
      fd.append("contact_phone", formData.contact_phone || "");
      fd.append("contact_email", formData.contact_email || "");

      // Applicant Details
      fd.append("contact_applicant", formData.contactapplicant || "");
      fd.append("yf_applicant_name", formData.yf_applicant_name || "");
      fd.append("applicant_dob", formData.ApplicantDOB || "");
      fd.append("applicant_designation", formData.Applicantdesignation || "");
      fd.append("applicant_profile", formData.Applicantprofile || "");
      fd.append("applicant_details", formData.Applicantdetails || "");
      fd.append("applicant_joining", formData.Applicantjoining || "");

      // Qualitative Info
      fd.append("company_profile", formData.companyProfile || "");
      fd.append("award_justification", formData.awardJustification || "");
      fd.append("comment", formData.comment || "");
      fd.append("declaration", formData.declaration ? "true" : "false");

      // Quantitative Answers
      fd.append("yf_1", formData.YF_1 || "");
      fd.append("yf_2", formData.YF_2 || "");
      fd.append("yf_3", formData.YF_3 || "");
      fd.append("yf_4", formData.YF_4 || "");
      fd.append("yf_5", formData.YF_5 || "");
      fd.append("yf_6", formData.YF_6 || "");

      // Signature File
      fd.append("form_id", formId);
      fd.append("form_mode", clickType);
      // Add Table Pk Id;
      if (PkId > 0) fd.append("id", PkId);

      if (payload.approvingAuthoritySignature instanceof File) {
        fd.append(
          "approving_authority_file",
          payload.approvingAuthoritySignature
        );
      }

      // Attachments 1–4
      for (let i = 1; i <= 4; i++) {
        const attachment = formData[`attachments${i}`];
        if (attachment) {
          fd.append(`attachments${i}_desc`, attachment.description || "");
          if (attachment.file instanceof File) {
            fd.append(`attachments${i}`, attachment.file);
          }
        }
      }

      // Submit form
      //     await apiClient.post("/registration-youngfemale/", fd, {
      //       headers: { "Content-Type": "multipart/form-data" },
      //     });

      //     // Optional: clear formData or redirect
      //   } catch (error) {
      //     console.error("Submission error:", error);
      //     alert("Submission failed: " + (error.response?.data?.detail || error.message));
      //   }
      // }

      try {
        const response = await apiClient.post(
          "/registration-youngfemale/",
          fd,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        // When User save the Data It will Prefill the form data and fill pkId
        prefillFormData();
      } catch (err) {
        console.error("registration-youngfemale submission error:", err);
        const serverMsg =
          err?.response?.data ?? err?.message ?? JSON.stringify(err);
        alert("Submission failed: " + JSON.stringify(serverMsg));
      }
    } catch (err) {
      console.error(`Error submitting form :: ${err}`);
    }
  }

  function escapeHtml(str = "") {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  const handlePrint = () => {
    const title = escapeHtml(awardTitle || "");

    const bodyHtml = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${title}</h1>

      <h2>Organization Details</h2>
      <p><strong>Organisation Name:</strong> ${escapeHtml(
        formData.Organisationname || ""
      )}</p>
      <p><strong>Postal Address:</strong> ${escapeHtml(
        formData.mailingAddress || ""
      )}</p>
      <p><strong>Approving Authority Name:</strong> ${escapeHtml(
        formData.authorityName || ""
      )}</p>
      <p><strong>Approving Authority Designation:</strong> ${escapeHtml(
        formData.authorityTitle || ""
      )}</p>
      <p><strong>Approving Authority Landline:</strong> ${escapeHtml(
        formData.authorityLandline || ""
      )}</p>
      <p><strong>Approving Authority Phone:</strong> ${escapeHtml(
        formData.authorityPhone || ""
      )}</p>
      <p><strong>Approving Authority Email:</strong> ${escapeHtml(
        formData.authorityEmail || ""
      )}</p>

      <h3>Corporate HR Head:</h3>
      <p><strong>HR Name:</strong> ${escapeHtml(formData.HRName || "")}</p>
      <p><strong>HR Phone:</strong> ${escapeHtml(formData.HRPhone || "")}</p>
      <p><strong>HR Email:</strong> ${escapeHtml(formData.HREmail || "")}</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Contact Name:</strong> ${escapeHtml(
        formData.contact_name || ""
      )}</p>
      <p><strong>Contact Phone:</strong> ${escapeHtml(
        formData.contact_phone || ""
      )}</p>
      <p><strong>Contact Email:</strong> ${escapeHtml(
        formData.contact_email || ""
      )}</p>

      <h2>Applicant Details:</h2>
      <p><strong>Contact Number:</strong> ${escapeHtml(
        formData.contactapplicant || ""
      )}</p>
      <p><strong>Date of Birth:</strong> ${escapeHtml(
        formData.ApplicantDOB || ""
      )}</p>
      <p><strong>Designation:</strong> ${escapeHtml(
        formData.Applicantdesignation || ""
      )}</p>
      <p><strong>Career Profile:</strong> ${escapeHtml(
        formData.Applicantprofile || ""
      )}</p>
      <p><strong>Educational Qualifications:</strong> ${escapeHtml(
        formData.Applicantdetails || ""
      )}</p>
      <p><strong>Date of Joining:</strong> ${escapeHtml(
        formData.Applicantjoining || ""
      )}</p>
     <br/>
      <p><strong>Mention the rationale behind applying for this award (emphasis on quantitative achievement):</strong> ${escapeHtml(
        formData.companyProfile || ""
      )}</p>

      <h2>Quantitative Information Part 1</h2>
      <table border="1" style="border-collapse: collapse; width: 100%;">
        <tbody>
          <tr>
            <th style="text-align:left; padding:8px;">1. Initiatives/exceptional contribution in the line of work</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_1 || "")}</td>
          </tr>
          <tr>
            <th style="text-align:left; padding:8px;">2. Examples of creativity/technique/imagination demonstrated in your line of work that set you apart from your peers</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_2 || "")}</td>
          </tr>
          <tr>
            <th style="text-align:left; padding:8px;">3. Leadership role played/example of project spearheaded by you/example of exceptional performance as team member</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_3 || "")}</td>
          </tr>
          <tr>
            <th style="text-align:left; padding:8px;">4. How has the oil and gas sector/company benefited from your leadership/work?</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_4 || "")}</td>
          </tr>
        </tbody>
      </table>

      <h2>Quantitative Information Part 2</h2>
      <table border="1" style="border-collapse: collapse; width: 100%; margin-top:12px;">
        <tbody>
          <tr>
            <th style="text-align:left; padding:8px;">5. Outline barriers or difficulties you faced and how they have been overcome</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_5 || "")}</td>
          </tr>
          <tr>
            <th style="text-align:left; padding:8px;">6. Work done/achievements (if any) in the area of environmental improvement/decarbonization/net zero targets</th>
            <td style="padding:8px;">${escapeHtml(formData.YF_6 || "")}</td>
          </tr>
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px; text-align:center; width:10px">S.No</th>
            <th style="border: 1px solid #000; padding: 8px; text-align:left;">Description</th>
            <th style="border: 1px solid #000; padding: 8px; text-align:left;">File Name</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4]
            .map((i) => {
              const att = formData[`attachments${i}`] || {};
              const desc = escapeHtml(att.description || "");
              const fname = escapeHtml((att.file && att.file.name) || "");
              return `
                <tr>
                  <td style="border: 1px solid #000; padding: 8px; text-align:center;">${i}</td>
                  <td style="border: 1px solid #000; padding: 8px; text-align:start;">${desc}</td>
                  <td style="border: 1px solid #000; padding: 8px; text-align:start;">${fname}</td>
                </tr>
              `;
            })
            .join("")}
        </tbody>
      </table>

      <h2>Comments</h2>
      <p>${escapeHtml(formData.comment || "")}</p>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>

      <p><strong>Approving Authority Name:</strong> ${escapeHtml(
        formData.authorityName || ""
      )}</p>
      <p><strong>Approving Authority Designation:</strong> ${escapeHtml(
        formData.authorityTitle || ""
      )}</p>
      <p><strong>Signed on:</strong> ${escapeHtml(
        formData.signatureDate || new Date().toLocaleDateString()
      )}</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

    const fullHtml = `<!doctype html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>${title}</title>
        <style>
          @page { margin: 20mm; }
          body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
        </style>
      </head>
      <body>${bodyHtml}</body>
    </html>`;

    const printWindow = window.open("", "_blank", "height=800,width=1000");
    printWindow.document.open();
    printWindow.document.write(fullHtml);
    printWindow.document.close();

    // set title to avoid about:blank in header/footer
    try {
      printWindow.document.title = title;
    } catch (e) {
      /* ignore */
    }

    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      // printWindow.close(); // optional
    }, 300);
  };

  const fullData = [
    ["1", "Initiatives/exceptional contribution in the line of work", "YF_1"],
    [
      "2",
      "Examples of creativity/technique/imagination demonstrated in your line of work that set you apart from your peers",
      "YF_2",
    ],
    [
      "3",
      "Leadership role played/example of project spearheaded by you/example of exceptional performance as team member in your line of work which helped you contributed differently from the defined level of expertise",
      "YF_3",
    ],
    [
      "4",
      "How has the oil and gas sector/company benefited from your leadership/work?",
      "YF_4",
    ],
    [
      "5",
      "Outline barriers or difficulties you faced and how they have been overcome",
      "YF_5",
    ],
    [
      "6",
      "Work done/achievements (if any) in the area of environmental improvement/decarbonization/net zero targets",
      "YF_6",
    ],
  ];

  const part1 = fullData.filter(([num]) => parseFloat(num) <= 4);
  const part2 = fullData.filter(([num]) => parseFloat(num) > 4);

  const hasEmptyFieldsInStep = (step) => {
    // Pick the list of fields for this step
    const fields = step === 3 ? part1 : part2;
    for (const [, , key] of fields) {
      if (!formData[key] || formData[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;
    return (
      <div className="form-step">
        <div className="progress-bar">
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>

        {currentStep === 1 && (
          <div>
            <h3 className="step-title">Step 1: Organization Details</h3>
            <div className="form-group">
              <label>Organisation Name: </label>
              <input
                type="text"
                name="Organisationname"
                maxLength={FIELD_MAX_LENGTH}
                value={formData.Organisationname}
                // onChange={handleChange}
                disabled={true}
                className={`form-input ${
                  !formData.Organisationname && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
              />
              {!formData.Organisationname && currentStep === 1 && (
                <span className="error-tooltip">
                  Organisation name is required
                </span>
              )}
            </div>

            <div className="form-group">
              <label>
                Postal Address: <span className="text-red">*</span>
              </label>
              <textarea
                name="mailingAddress"
                maxLength={FIELD_MAX_LENGTH}
                value={formData.mailingAddress}
                onChange={handleChange}
                className={`form-textarea ${
                  !formData.mailingAddress.trim() && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
                rows={3}
                placeholder="Enter Postal address"
              />
              {!formData.mailingAddress.trim() && currentStep === 1 && (
                <span className="error-tooltip">
                  Mailing address is required
                </span>
              )}
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <h3 className="step-title">
              Step 2:Approving Authority, Contact & Applicant Details
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="step-section">
                <h4>Approving Authority</h4>
                <p className="note">
                  Approving authority should be Director (HR) in case of PSUs
                  and CEOs in case of Private Companies.
                </p>
                <div className="form-group">
                  <label>
                    Name: <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="authorityName"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityName}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.authorityName && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Name"
                  />
                  {!formData.authorityName && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority name is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Designation: <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="authorityTitle"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityTitle}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.authorityTitle && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Designation"
                  />
                  {!formData.authorityTitle && currentStep === 2 && (
                    <span className="error-tooltip">
                      Designation is required
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Landline:{" "}
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityLandline"
                    type="number"
                    name="authorityLandline"
                    value={formData.authorityLandline}
                    onChange={handleChange}
                    // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                    className={`form-input ${
                      !formData.authorityLandline && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Landline number"
                    aria-required="true"
                    aria-describedby={
                      fieldErrors.authorityLandline
                        ? "authorityLandline-error"
                        : undefined
                    }
                  />
                  {!formData.authorityLandline && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority Landline Number is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">Mobile: </label>
                  <input
                    id="authorityPhone"
                    type="tel"
                    name="authorityPhone"
                    value={formData.authorityPhone}
                    onChange={handleChange}
                    // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                    className={`form-input`}
                    placeholder="Phone number"
                    maxLength={PHONE_MAX_LENGTH}
                    aria-required="true"
                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                  />
                </div>

                <div className="form-group">
                  <label>
                    Email: <span className="text-red">*</span>
                  </label>
                  <input
                    type="email"
                    name="authorityEmail"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityEmail}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.authorityEmail && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="E-mail address"
                  />
                  {!formData.authorityEmail && currentStep === 2 && (
                    <span className="error-tooltip">Email is required</span>
                  )}
                </div>
              </div>
              <div className="step-section">
                <h4>Corporate HR Head </h4>
                <div className="form-group">
                  <label>
                    Name: <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="HRName"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.HRName}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.HRName && currentStep === 2 ? "has-error" : ""
                    }`}
                    placeholder="Name"
                  />
                  {!formData.HRName && currentStep === 2 && (
                    <span className="error-tooltip">HR name is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Phone: <span className="text-red">*</span>
                  </label>
                  <input
                    type="tel"
                    name="HRPhone"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.HRPhone}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.HRPhone && currentStep === 2 ? "has-error" : ""
                    }`}
                    placeholder="Phone number"
                  />
                  {!formData.HRPhone && currentStep === 2 && (
                    <span className="error-tooltip">Phone is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Email: <span className="text-red">*</span>
                  </label>
                  <input
                    type="email"
                    name="HREmail"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.HREmail}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.HREmail && currentStep === 2 ? "has-error" : ""
                    }`}
                    placeholder="E-mail address"
                  />
                  {!formData.HREmail && currentStep === 2 && (
                    <span className="error-tooltip">Email is required</span>
                  )}
                </div>
              </div>
              <div className="step-section">
                <h4>Contacts (Nodal Officials)</h4>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      //   checked={copyApplicantData}
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={handleChange}
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.contact_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={handleChange}
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contact_phone && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">
                    Email
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={handleChange}
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      fieldErrors.contact_email ? "has-error" : ""
                    }`}
                    aria-describedby="contact_email-error"
                  />
                </div>
              </div>
              <div className="step-section">
                <h4>Applicant Details</h4>
                <div className="form-group">
                  <label htmlFor="yf_applicant_name">
                    Applicant Name{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="yf_applicant_name"
                    name="yf_applicant_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.yf_applicant_name}
                    onChange={handleChange}
                    placeholder="Applicant name"
                    // disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.yf_applicant_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="yf_applicant_name-error"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="contactapplicant">
                    Contact details:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contactapplicant"
                    name="contactapplicant"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contactapplicant}
                    onChange={handleChange}
                    aria-describedby="contactapplicant-error"
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contactapplicant && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.contactapplicant && (
                    <span
                      className="error-tooltip"
                      id="contactapplicant-error"
                      role="alert"
                    >
                      {fieldErrors.contactapplicant}
                    </span>
                  )}
                  {!formData.contactapplicant && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="contactapplicant-error"
                      role="alert"
                    >
                      Phone is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Date of Birth:<span className="text-red">*</span>
                  </label>
                  <p className="note">(DD/MM/YYYY) </p>
                  <input
                    type="date"
                    name="ApplicantDOB"
                    value={formData.ApplicantDOB}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.ApplicantDOB && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                  />
                  {!formData.ApplicantDOB && currentStep === 2 && (
                    <span className="error-tooltip">DOB is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Current Designation: <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="Applicantdesignation"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.Applicantdesignation}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.Applicantdesignation && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Applicant Designation"
                  />
                  {!formData.Applicantdesignation && currentStep === 2 && (
                    <span className="error-tooltip">
                      Designation is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Career Profile <span className="text-red">*</span>
                  </label>

                  <textarea
                    name="Applicantprofile"
                    // maxLength={COMPANY_PROFILE_MAX_LENGTH}
                    value={formData.Applicantprofile}
                    onChange={handleChange}
                    className={`form-textarea ${
                      !formData.Applicantprofile && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    rows={6}
                  />
                  {!formData.Applicantprofile && currentStep === 2 && (
                    <span className="error-tooltip">Profile is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Educational qualifications with name of institutions, years
                    passed out & total percentage of marks received/grade/points
                    (Graduation & upwards) <span className="text-red">*</span>
                  </label>

                  <textarea
                    name="Applicantdetails"
                    // maxLength={COMPANY_PROFILE_MAX_LENGTH}
                    value={formData.Applicantdetails}
                    onChange={handleChange}
                    className={`form-textarea ${
                      !formData.Applicantdetails && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    rows={6}
                  />
                  {!formData.Applicantdetails && currentStep === 2 && (
                    <span className="error-tooltip">
                      Applicant Details is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Date of joining the organization
                    <span className="text-red">*</span>
                  </label>
                  <input
                    type="date"
                    name="Applicantjoining"
                    value={formData.Applicantjoining}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.Applicantjoining && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Date of Joining"
                  />
                  {!formData.Applicantjoining && currentStep === 2 && (
                    <span className="error-tooltip">
                      Date of Joining is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="step-section">
              <div className="form-group">
                <label>
                  Mention the rationale behind applying for this award (emphasis
                  be on quantitative achievement such as cost saving, sale
                  enhancement, efficiency in energy consumption, safety,
                  environment etc.){" "}
                </label>
                <p className="note">
                  Write up by applicant (Not more than 300 words){" "}
                </p>
                <textarea
                  name="companyProfile"
                  // maxLength={COMPANY_PROFILE_MAX_LENGTH}
                  value={formData.companyProfile}
                  onChange={handleChange}
                  className="form-textarea"
                  rows={6}
                />
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div>
            <h3 className="step-title">
              Step 3: Quantitative Information Part 1
            </h3>
            {part1.map(([num, label, key]) => (
              <div key={key} className="form-group">
                <label>
                  {num}. {label} (Within 200 words)
                </label>
                <textarea
                  name={key}
                  // maxLength={TEXTAREA_MAX_LENGTH}
                  value={formData[key] || ""}
                  onChange={handleChange}
                  className="form-textarea"
                  rows={6}
                />
              </div>
            ))}
          </div>
        )}

        {currentStep === 4 && (
          <div>
            <h3 className="step-title">
              Step 4: Quantitative Information Part 2
            </h3>
            {part2.map(([num, label, key]) => (
              <div key={key} className="form-group">
                <label>
                  {num}. {label} (Within 200 words)
                </label>
                <textarea
                  name={key}
                  // maxLength={TEXTAREA_MAX_LENGTH}
                  value={formData[key] || ""}
                  onChange={handleChange}
                  className="form-textarea"
                  rows={6}
                />
              </div>
            ))}
            <div className="step-section">
              <div className="form-group">
                <label>Comments</label>
                <textarea
                  name="comment"
                  // maxLength={COMMENT_MAX_LENGTH}
                  value={formData.comment}
                  onChange={handleChange}
                  className="form-textarea"
                  placeholder="Comments in (200 words) against input parameter, if any"
                />
              </div>
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <div className="form-step">
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>
            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Description</th>
                    <th>Upload (only jpg, png, pdf, max 5 MB each)</th>
                  </tr>
                </thead>
                {/* <tbody>
                                    {[1, 2, 3, 4].map((num) => {
                                        const key = `attachments${num}`;
                                        const attachment = formData[key];
                                        return (
                                            <tr key={key}>
                                                <td>{num}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={`${key}.description`}
                                                        maxLength={FIELD_MAX_LENGTH}
                                                        value={attachment.description}
                                                        onChange={(e) =>
                                                            handleAttachmentChange(key, 'description', e.target.value)
                                                        }
                                                        placeholder="Enter description"
                                                        className="form-input"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.png,.pdf"
                                                        onChange={(e) =>
                                                            handleAttachmentChange(key, 'file', e.target.files[0], e)
                                                        }
                                                        className="form-input mt-4"
                                                    />
                                                    {attachment.file && (
                                                        <p className="file-name">Selected file: {attachment.file.name}</p>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || {
                      description: "",
                      file: null,
                    };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            maxLength={FIELD_MAX_LENGTH}
                            className="form-input"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">
                              Selected file: {attachment.file.name}
                            </p>
                          )}
                          {attachment.url && !attachment.file && (
                            <p className="file-name">
                              Uploaded file:{" "}
                              <button
                                type="button"
                                onClick={() => viewFile(attachment.url)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  color: "#06c",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                View
                              </button>
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="form-group">
              <label>
                Print the completed application form and upload it with the
                signature of the approving authority. Without signature of the
                approving authority, application will not be considered valid.
                <span className="text-red">*</span>
              </label>
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={handlePrint}
                  className="btn btn-outline"
                >
                  Print Preview
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="approvingAuthoritySignature">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approvingAuthoritySignature"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approvingAuthoritySignature ? "has-error" : ""
                }`}
                aria-describedby="approvingAuthoritySignature-error"
                required
              />
              {formData.approvingAuthoritySignature && (
                <p className="file-name">
                  Selected file: {formData.approvingAuthoritySignature.name}
                </p>
              )}
              {formData.approvingAuthoritySignatureUrl &&
                !formData.approvingAuthoritySignature && (
                  <p className="file-name">
                    Uploaded file:{" "}
                    <button
                      type="button"
                      onClick={() =>
                        viewFile(formData.approvingAuthoritySignatureUrl)
                      }
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        color: "#06c",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  </p>
                )}
              {fieldErrors.approvingAuthoritySignature && (
                <span
                  className="error-tooltip"
                  id="approvingAuthoritySignature-error"
                  role="alert"
                >
                  {fieldErrors.approvingAuthoritySignature}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                I declare that the information submitted is true and complete.
              </label>
            </div>
          </div>
        )}
      </div>
    );
  };
  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: "smooth" });
  }, [currentStep]);

  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline
        isOpen={true}
        sidebarItems={[{ id: "Guideline", label: "Guideline" }]}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        selectedAwardCategory={formData.category}
      />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <p>Step {currentStep} of 5</p>
        </div>
        {error && <div className="error">{error}</div>}
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
            <button onClick={() => navigate("/#Award%20Categories")}>
              Submit Another Application
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {renderStepContent()}
            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  className="btn btn-primary"
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            )}
            {currentStep > 1 && (
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={prevStep}
                  className="btn btn-outline"
                >
                  <ChevronLeft size={16} /> Previous
                </button>
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                {currentStep < 5 && (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="btn btn-primary"
                  >
                    Next <ChevronRight size={16} />
                  </button>
                )}
                {currentStep === 5 && (
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert(
                          "Please accept the declaration before submitting."
                        );
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert(
                          "Please upload the approving authority signature file."
                        );
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();
                      }
                      alert(
                        "Young Female registration submitted successfully!"
                      );
                      setIsSubmitted(true);

                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationYF;
